import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { fechonegastenprofiel, updategastenprofiel } from '../Reducers/actions';
import { message } from '../../../Reducers/loading/actions';
import EditForm from './Components/edit';
import { useParams, useNavigate } from 'react-router-dom';

const GastenProfielEdit = () => {
  const [loaded, setLoaded] = useState(false);
  const [activeTab, setActiveTab] = useState(0); // Changed to index-based
  const params = useParams();
  const navigate = useNavigate()

  // Tab mapping for backward compatibility
  const tabMapping = ['algemeen', 'stroom', 'betalingen', 'app', 'kiosk'];

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fechonegastenprofiel(params.id)).then(data => {
      setLoaded(true);
    });
  }, [dispatch, params.id]);

  const submit = (vals, activeTab, setActiveTab) => {
    delete vals['data'];
    dispatch(updategastenprofiel(params.id, vals)).then(data => {
      if (data.type === "SENSOR_ERROR") {
        dispatch(message(5000, "error", data.payload));
        return false;
      } else {
        // Move to next tab instead of navigating away
        if (activeTab < tabMapping.length - 1) {
          setActiveTab(activeTab + 1);
          dispatch(message(3000, "success", "Gastenprofiel bijgewerkt - ga door naar het volgende tabblad"));
        } else {
          // If on last tab, show success message and navigate to gastenprofiel list
          dispatch(message(5000, "success", "Gastenprofiel succesvol bijgewerkt!"));
          navigate('/gastenverbruik/gastenprofiel');
        }
      }
    });
  }

  return (
    <div className="box box-default">
      <div className="box-header with-border">
        <h3 className="box-title">GastenProfiel wijzigen</h3>
      </div>

      <div className="row">
        <div className="col-md-12 no-float">
          <div className="box box-primary">
            <div className="box-body box-profile">
              {loaded &&
                <EditForm 
                  onSubmit={(vals) => submit(vals, activeTab, setActiveTab)} 
                  activeTab={activeTab}
                  setActiveTab={setActiveTab}
                />
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default GastenProfielEdit;
